import React from "react";
import {
  Alert,
  Badge,
  Form,
  Icon,
  Input,
  Button,
  Select,
  Tabs,
  Row,
  Col,
  AutoComplete,
  InputNumber,
  Tooltip,
  Checkbox,
  DatePicker,
  Modal,
} from "antd";
import ReactQuill from "react-quill";
import moment from "moment";
import get from "lodash/get";
import remove from "lodash/remove";
import map from "lodash/map";
import forEach from "lodash/forEach";
import { connect } from "react-redux";
import {
  SortableContainer,
  SortableElement,
  SortableHandle,
} from "react-sortable-hoc";

import {
  getDelegationLogStaffAllRequest,
  getDelegationLogStaffMissingRequest,
  getDelegationLogRolesAllRequest,
  getDelegationLogRolesMissingRequest,
  putDelegationLogRequest,
} from "../../api/requests";

import { getDelegationLogAdminUpdatePermission } from "../../reducers/user/selectors";

import classes from "./DelegationLogs.css";
import { logout } from "../../reducers/user/actions";
import { withNamespaces } from "react-i18next";
import { v4 as uuidv4 } from "uuid";
import arrayMove from "../../utils/arrayMove";
import Signature from "../FormBuilder/Signature/Signature";

const { Option } = Select;
const { TabPane } = Tabs;

function hasErrors(fieldsError) {
  return Object.keys(fieldsError).some((field) => fieldsError[field]);
}

const SortableTaskList = SortableContainer(({ ...props }) => {
  return (
    <div className={classes.structureWrapper}>
      {map(props.tasksKeys, (taskKey, index) => (
        <SortableTaskItem
          key={taskKey}
          index={index}
          taskKey={taskKey}
          i={index}
          {...props}
        />
      ))}
    </div>
  );
});

const SortableTaskItem = SortableElement(({ value, ...props }) => {
  return (
    <div className={classes.structureItem}>
      <div className={classes.structureItemControls}>
        <DragHandle field={props.i + 1} />

        {props.isEditable && props.delegationLog.status === "draft" && (
          <div className={classes.structureItemAction}>
            <Icon
              style={{ margin: "3px 0 5px 0", color: "#f00" }}
              type="delete"
              onClick={() => props.onDeleteTask(props.taskKey)}
            />
          </div>
        )}
      </div>
      <div className={classes.structureItemWrap}>
        <div className={classes.structureItemContent}>
          <Form.Item label={props.i18n.t("Task name")}>
            {props.form.getFieldDecorator(`tasks[${props.taskKey}].name`, {
              rules: [{ required: true, message: props.i18n.t("Required") }],
              initialValue: get(props.tasks, `${props.taskKey}.name`),
            })(<Input disabled={!props.isEditable} />)}
          </Form.Item>
        </div>
      </div>
    </div>
  );
});

const SortableRolesList = SortableContainer(({ ...props }) => {
  return (
    <div className={classes.structureWrapper}>
      {map(props.rolesKeys, (roleKey, index) => (
        <SortableRoleItem
          key={roleKey}
          index={index}
          roleKey={roleKey}
          i={index}
          {...props}
        />
      ))}
    </div>
  );
});

const SortableRoleItem = SortableElement(({ value, ...props }) => {
  return (
    <div className={classes.structureItem}>
      <div className={classes.structureItemControls}>
        <DragHandle field={props.i + 1} />

        {props.isEditable && props.delegationLog.status === "draft" && (
          <div className={classes.structureItemAction}>
            <Icon
              style={{ margin: "3px 0 5px 0", color: "#f00" }}
              type="delete"
              onClick={() => props.onDeleteRole(props.roleKey)}
            />
          </div>
        )}
      </div>
      <div className={classes.structureItemWrap}>
        <div className={classes.structureItemContent}>
          <Form.Item
            label={props.i18n.t("Existing role name")}
            style={{
              opacity: props.form.getFieldValue(
                `roles[${props.roleKey}].custom_name`
              )
                ? ".5"
                : "1",
            }}
          >
            {props.form.getFieldDecorator(`roles[${props.roleKey}].name`, {
              rules: [
                {
                  required: !props.form.getFieldValue(
                    `roles[${props.roleKey}].custom_name`
                  ),
                  message: props.i18n.t("Required"),
                },
              ],
              initialValue: get(props.roles, `${props.roleKey}.user_role_id`)
                ? `${get(props.roles, `${props.roleKey}.user_role_id`)};${get(
                    props.roles,
                    `${props.roleKey}.name`
                  )}`
                : null,
            })(
              <Select
                style={{ width: "100%" }}
                disabled={!props.isEditable}
                showSearch
                onChange={() => {
                  props.form.setFieldsValue({
                    [`roles[${props.roleKey}].custom_name`]: "",
                  });
                }}
              >
                {props.rolesListSearch
                  .filter(({ id, name }) => {
                    const roles = props.form.getFieldValue("roles");
                    if (Array.isArray(roles)) {
                      const rolesVal = Object.keys(roles).map(
                        (rolesKeyCalc) => `${roles[rolesKeyCalc].name}`
                      );

                      return (
                        !rolesVal.includes(`${id};${name}`) ||
                        `${id};${name}` ===
                          props.form.getFieldValue(
                            `roles[${props.roleKey}].name`
                          )
                      );
                    } else {
                      return true;
                    }
                  })
                  .map(({ id, name }) => (
                    <Option key={id} value={`${id};${name}`}>
                      {name}
                    </Option>
                  ))}
              </Select>
            )}
          </Form.Item>
        </div>
      </div>

      <div className={classes.structureItemWrap}>
        <div
          className={classes.structureItemContent}
          style={{
            opacity: props.form.getFieldValue(`roles[${props.roleKey}].name`)
              ? ".5"
              : "1",
          }}
        >
          <b>OR</b>
          <Form.Item label={props.i18n.t("Custom role name")}>
            {props.form.getFieldDecorator(
              `roles[${props.roleKey}].custom_name`,
              {
                rules: [
                  {
                    required: !props.form.getFieldValue(
                      `roles[${props.roleKey}].name`
                    ),
                    message: props.i18n.t("Required"),
                  },
                ],
                initialValue: !get(props.roles, `${props.roleKey}.user_role_id`)
                  ? get(props.roles, `${props.roleKey}.name`)
                  : "",
              }
            )(
              <Input
                disabled={!props.isEditable}
                onChange={() => {
                  props.form.setFieldsValue({
                    [`roles[${props.roleKey}].name`]: "",
                  });
                }}
              />
            )}
          </Form.Item>
        </div>
      </div>

      <div>
        <Form.Item label={props.i18n.t("Tasks")}>
          {props.form.getFieldDecorator(`roles[${props.roleKey}].tasks`, {
            rules: [{ required: true, message: props.i18n.t("Required") }],
            initialValue: map(
              get(props.roles, `${props.roleKey}.tasks`),
              ({ uuid }) => uuid
            ),
          })(
            <Select
              mode="multiple"
              style={{ width: "100%" }}
              disabled={!props.isEditable}
            >
              {props.tasksKeys.map((taskKey) => (
                <Option key={taskKey} value={taskKey}>
                  {props.form.getFieldValue(`tasks[${taskKey}].name`)}
                </Option>
              ))}
            </Select>
          )}
        </Form.Item>
      </div>
    </div>
  );
});

const SortableStaffList = SortableContainer(({ ...props }) => {
  return (
    <div className={classes.structureWrapper}>
      {map(props.staffKeys, (staffKey, index) => (
        <SortableStaffItem
          key={staffKey}
          index={index}
          staffKey={staffKey}
          i={index}
          {...props}
        />
      ))}
    </div>
  );
});

const SortableStaffItem = SortableElement(({ value, ...props }) => {
  return (
    <div className={classes.structureItem}>
      <div className={classes.structureItemControls}>
        <DragHandle field={props.i + 1} />

        {props.isEditableStaff && (
          <div className={classes.structureItemAction}>
            <Icon
              style={{ margin: "3px 0 5px 0", color: "#f00" }}
              type="delete"
              onClick={() => props.onDeleteStaff(props.staffKey)}
            />
          </div>
        )}
      </div>
      <div className={classes.structureItemWrap}>
        <div className={classes.structureItemContent}>
          <Form.Item label={props.i18n.t("Name")}>
            {props.form.getFieldDecorator(`staff[${props.staffKey}].name`, {
              rules: [{ required: true, message: props.i18n.t("Required") }],
              initialValue: get(props.staff, `${props.staffKey}.user_id`)
                ? `${get(props.staff, `${props.staffKey}.user_id`)};${get(
                    props.staff,
                    `${props.staffKey}.name`
                  )}`
                : null,
            })(
              <Select
                style={{ width: "100%" }}
                disabled={!(props.isEditable || props.isEditableStaff)}
                showSearch
              >
                {props.staffImport
                  .filter(({ user_id, name }) => {
                    const staff = props.form.getFieldValue("staff");
                    if (Array.isArray(staff)) {
                      const staffVal = Object.keys(staff).map(
                        (staffKeyCalc) => `${staff[staffKeyCalc].name}`
                      );

                      return (
                        !staffVal.includes(`${user_id};${name}`) ||
                        `${user_id};${name}` ===
                          props.form.getFieldValue(
                            `staff[${props.staffKey}].name`
                          )
                      );
                    } else {
                      return true;
                    }
                  })
                  .map(({ user_id, name }) => (
                    <Option key={user_id} value={`${user_id};${name}`}>
                      {name}
                    </Option>
                  ))}
              </Select>
            )}
          </Form.Item>
        </div>
      </div>

      <div>
        {props.form.getFieldDecorator(
          `staff[${props.staffKey}].is_qualified_investigator`,
          {
            initialValue: get(
              props.staff,
              `${props.staffKey}.is_qualified_investigator`,
              false
            ),
            valuePropName: "checked",
          }
        )(
          <Checkbox
            disabled={!(props.isEditable || props.isEditableStaff)}
            onClick={() => {
              forEach(props.staffKeys, (staffKey) => {
                if (staffKey !== props.staffKey) {
                  props.form.setFieldsValue({
                    [`staff[${staffKey}].is_qualified_investigator`]: false,
                  });
                }
              });
            }}
          >
            {props.i18n.t("QI")}
          </Checkbox>
        )}
      </div>

      <div style={{ marginTop: "20px" }}>
        <Form.Item label={props.i18n.t("NamespaceDelegationLogs:Date of delegation")}>
          {props.form.getFieldDecorator(
            `staff[${props.staffKey}].start_of_tasks_dt`,
            {
              rules: [{ required: true, message: props.i18n.t("Required") }],
              initialValue: get(
                props.staff,
                `${props.staffKey}.start_of_tasks_dt`
              )
                ? moment(
                    get(props.staff, `${props.staffKey}.start_of_tasks_dt`)
                  )
                : null,
            }
          )(
            <DatePicker
              disabled={!(props.isEditable || props.isEditableStaff)}
              placeholder="DD/MM/YYYY"
              format="DD/MM/YYYY"
            />
          )}
        </Form.Item>
      </div>

      <div>
        <Form.Item label={props.i18n.t("NamespaceDelegationLogs:End of tasks")}>
          {props.form.getFieldDecorator(
            `staff[${props.staffKey}].end_of_tasks_dt`,
            {
              initialValue: get(
                props.staff,
                `${props.staffKey}.end_of_tasks_dt`
              )
                ? moment(get(props.staff, `${props.staffKey}.end_of_tasks_dt`))
                : null,
            }
          )(
            <DatePicker
              disabled={!(props.isEditable || props.isEditableStaff)}
              placeholder="DD/MM/YYYY"
              format="DD/MM/YYYY"
            />
          )}
        </Form.Item>
      </div>

      <div>
        <Form.Item label={props.i18n.t("NamespaceDelegationLogs:Roles")}>
          {props.form.getFieldDecorator(`staff[${props.staffKey}].roles`, {
            rules: [{ required: true, message: props.i18n.t("Required") }],
            initialValue: map(
              get(props.staff, `${props.staffKey}.roles`),
              ({ uuid }) => uuid
            ),
          })(
            <Select
              mode="multiple"
              style={{ width: "100%" }}
              disabled={!(props.isEditable || props.isEditableStaff)}
            >
              {props.rolesKeys.map((roleKey) => (
                <Option key={roleKey} value={roleKey}>
                  {props.form.getFieldValue(`roles[${roleKey}].name`)
                    ? props.form
                        .getFieldValue(`roles[${roleKey}].name`)
                        .split(";")[1]
                    : props.form.getFieldValue(`roles[${roleKey}].custom_name`)}
                </Option>
              ))}
            </Select>
          )}
        </Form.Item>
      </div>
    </div>
  );
});

const DragHandle = SortableHandle(({ field }) => (
  <span tabIndex={0} className={classes.dragHandler}>
    <Icon type="drag" tabIndex={-1} className={classes.dragHandlerIcon} />
    <Tooltip placement="topLeft" title="Field Index">
      <Badge count={field} style={{ backgroundColor: "#2db7f5" }} />
    </Tooltip>
  </span>
));

class DelegationLogForm extends React.Component {
  constructor(props) {
    super(props);

    this.quillRef = React.createRef();

    const tasks = {};
    forEach(this.props.delegationLog.tasks, (task) => {
      tasks[task.uuid] = task;
    });

    const roles = {};
    forEach(this.props.delegationLog.roles, (role) => {
      roles[role.uuid] = role;
    });

    const staff = {};
    forEach(this.props.delegationLog.staff_members, (staffItem) => {
      staff[staffItem.uuid] = staffItem;
    });

    this.state = {
      rolesListSearch: this.props.rolesList.map(({ id, name }) => ({
        id,
        name,
      })),
      isLoading: false,
      requestResult: {},
      tasks,
      tasksKeys: map(
        this.props.delegationLog.tasks.sort((a, b) => a.index - b.index),
        ({ uuid }) => uuid
      ),
      roles,
      rolesKeys: map(
        this.props.delegationLog.roles.sort((a, b) => a.index - b.index),
        ({ uuid }) => uuid
      ),
      staff,
      staffKeys: map(
        this.props.delegationLog.staff_members.sort(
          (a, b) => a.index - b.index
        ),
        ({ uuid }) => uuid
      ),
      roleSearch: null,
      errors: null,
      isStaffImportAllLoading: false,
      isStaffImportMissingLoading: false,
      isRolesImportAllLoading: false,
      isRolesImportMissingLoading: false,
      isDeletedUser: false,
      isEndDelegationConfirmOpen: false,
    };
  }

  getStaffImportAll = async () => {
    this.setState({ isStaffImportAllLoading: true });
    try {
      const { data } = await getDelegationLogStaffAllRequest({
        id: this.props.id,
      });
      this.replaceStaffFromImport(data);
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
      }
    }

    this.setState({ isStaffImportAllLoading: false });
  };

  getStaffImportMissing = async () => {
    this.setState({ isStaffImportMissingLoading: true });
    try {
      const { data } = await getDelegationLogStaffMissingRequest({
        id: this.props.id,
      });
      this.replaceStaffFromImport(data);
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
      }
    }

    this.setState({ isStaffImportMissingLoading: false });
  };

  getRolesImportAll = async () => {
    this.setState({ isRolesImportAllLoading: true });
    try {
      const { data } = await getDelegationLogRolesAllRequest({
        id: this.props.id,
      });
      this.replaceRolesFromImport(data);
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
      }
    }

    this.setState({ isRolesImportAllLoading: false });
  };

  getRolesImportMissing = async () => {
    this.setState({ isRolesImportMissingLoading: true });
    try {
      const { data } = await getDelegationLogRolesMissingRequest({
        id: this.props.id,
      });
      this.replaceRolesFromImport(data);
    } catch (e) {
      if (get(e, "response.status") === 401) {
        this.props.logout();
      }
    }

    this.setState({ isRolesImportMissingLoading: false });
  };

  replaceRolesFromImport = (data) => {
    this.setState({
      roles: {},
      rolesKeys: [],
    });

    forEach(this.state.staffKeys, (staffKey) => {
      this.props.form.setFieldsValue({
        [`staff[${staffKey}].roles`]: [],
      });
    });

    const roles = {};
    forEach(data, (role) => {
      roles[role.uuid] = role;
    });

    this.setState({
      roles,
      rolesKeys: map(
        data.sort((a, b) => a.index - b.index),
        ({ uuid }) => uuid
      ),
    });
  };

  replaceStaffFromImport = (data) => {
    this.setState({
      staff: {},
      staffKeys: [],
    });

    const staff = {};
    forEach(data, (staffItem) => {
      staff[staffItem.uuid] = staffItem;
    });

    this.setState({
      staff,
      staffKeys: map(
        data.sort((a, b) => a.index - b.index),
        ({ uuid }) => uuid
      ),
    });
  };

  onBlurRole = () => {
    this.setState({
      roleSearch: null,
    });
  };

  onSearchRole = (val) => {
    this.setState({
      roleSearch: val,
    });
  };

  handleSubmit = (e) => {
    e.preventDefault();

    this.setState({
      errors: null,
    });

    this.props.form.validateFields(async (err, values) => {
      this.setState({ isSubmitted: true, requestResult: {} });

      if (!err) {
        this.setState({ isLoading: true });

        try {
          const delegationsLogs = {};
          delegationsLogs.sponsor_name = values.sponsor_name;
          // delegationsLogs.protocol_number = values.protocol_number;
          delegationsLogs.description = values.description;
          delegationsLogs.template_type = values.template_type;
          delegationsLogs.note = values.note;
          delegationsLogs.tasks = [];
          delegationsLogs.roles = [];
          delegationsLogs.staff = [];

          if (values.initials && values.confirm) {
            delegationsLogs.end_of_delegation = {
              confirm: values.confirm,
              initials: values.initials,
            };
          }

          forEach(this.state.tasksKeys, (taskKey, index) => {
            delegationsLogs.tasks.push({
              name: values.tasks[taskKey].name,
              uuid: taskKey,
              index: index + 1,
            });
          });

          forEach(this.state.rolesKeys, (roleKey, index) => {
            delegationsLogs.roles.push({
              name: values.roles[roleKey].name
                ? values.roles[roleKey].name.split(";")[1]
                : values.roles[roleKey].custom_name,
              user_role_id: values.roles[roleKey].name
                ? values.roles[roleKey].name.split(";")[0]
                : undefined,
              uuid: roleKey,
              index: index + 1,
              tasks: values.roles[roleKey].tasks,
            });
          });

          forEach(this.state.staffKeys, (staffKey, index) => {
            delegationsLogs.staff.push({
              name: values.staff[staffKey].name.split(";")[1],
              user_id: values.staff[staffKey].name.split(";")[0],
              uuid: staffKey,
              index: index + 1,
              roles: values.staff[staffKey].roles,
              is_qualified_investigator:
                values.staff[staffKey].is_qualified_investigator,
              start_of_tasks_dt:
                moment(values.staff[staffKey].start_of_tasks_dt).format(
                  "YYYY-MM-DD"
                ) + "T12:00:00",
              end_of_tasks_dt: values.staff[staffKey].end_of_tasks_dt
                ? moment(values.staff[staffKey].end_of_tasks_dt).format(
                    "YYYY-MM-DD"
                  ) + "T12:00:00"
                : undefined,
            });
          });

          await putDelegationLogRequest({
            id: this.props.id,
            data: delegationsLogs,
          });

          this.setState({
            isLoading: false,
            isEndDelegationConfirmOpen: false,
            isDeletedUser: false,
            requestResult: {
              type: "success",
              message: this.props.i18n.t("Success"),
            },
          });
        } catch (e) {
          console.log(e);
          if (get(e, "response.status") === 401) {
            this.props.logout();
            return;
          }
          this.setState({
            isLoading: false,
            requestResult: {
              type: "error",
              message: get(e, "response.data.message", "Error"),
            },
            isEndDelegationConfirmOpen: false,
          });

          if (get(e, "response.data.errors")) {
            const errors = {};
            Object.keys(get(e, "response.data.errors")).forEach(
              (errorFieldKey) => {
                errors[errorFieldKey] = {
                  value: values[errorFieldKey],
                  errors: get(e, `response.data.errors.${errorFieldKey}`).map(
                    (errorMessage) => new Error(errorMessage)
                  ),
                };
              }
            );
            this.props.form.setFields(errors);
          }
        }
      } else {
        this.setState({
          errors: err,
        });
      }
    });
  };

  onTaskAdd = () => {
    const uuid = uuidv4();
    this.setState({
      tasksKeys: [...this.state.tasksKeys, uuid],
      tasks: { ...this.state.tasks, [uuid]: {} },
    });
  };

  onRoleAdd = () => {
    const uuid = uuidv4();
    this.setState({
      rolesKeys: [...this.state.rolesKeys, uuid],
      roles: { ...this.state.roles, [uuid]: {} },
    });
  };

  onStaffAdd = () => {
    const uuid = uuidv4();
    this.setState({
      staffKeys: [...this.state.staffKeys, uuid],
      staff: { ...this.state.staff, [uuid]: {} },
    });
  };

  onDeleteTask = (taskKey) => {
    const roles = this.props.form.getFieldValue("roles");
    if (roles) {
      forEach(Object.keys(roles), (roleKey) => {
        if (roles[roleKey].tasks) {
          forEach(roles[roleKey].tasks, (roleTaskKey) => {
            if (roleTaskKey === taskKey) {
              const updatedTasks = remove(
                this.props.form.getFieldValue(`roles[${roleKey}].tasks`),
                (item) => item !== taskKey
              );

              this.props.form.setFieldsValue({
                [`roles[${roleKey}].tasks`]: updatedTasks,
              });
            }
          });
        }
      });
    }

    const tasks = { ...this.state.tasks };
    delete tasks[taskKey];

    this.setState({
      tasksKeys: this.state.tasksKeys.filter(
        (taskKeyCurr) => taskKeyCurr !== taskKey
      ),
      tasks,
    });
  };

  onDeleteRole = (roleKey) => {
    const staff = this.props.form.getFieldValue("staff");

    if (staff) {
      forEach(Object.keys(staff), (staffKey) => {
        if (staff[staffKey].roles) {
          forEach(staff[staffKey].roles, (staffRoleKey) => {
            if (staffRoleKey === roleKey) {
              const updatedRoles = remove(
                this.props.form.getFieldValue(`staff[${staffKey}].roles`),
                (item) => item !== roleKey
              );

              this.props.form.setFieldsValue({
                [`staff[${staffKey}].roles`]: updatedRoles,
              });
            }
          });
        }
      });
    }

    const roles = { ...this.state.roles };
    delete roles[roleKey];

    this.setState({
      rolesKeys: this.state.rolesKeys.filter(
        (roleKeyCurr) => roleKeyCurr !== roleKey
      ),
      roles,
    });
  };

  onSortEndTasks = ({ oldIndex, newIndex }) => {
    this.setState(({ tasksKeys }) => ({
      tasksKeys: arrayMove(tasksKeys, oldIndex, newIndex),
    }));
  };

  onSortEndRole = ({ oldIndex, newIndex }) => {
    this.setState(({ rolesKeys }) => ({
      rolesKeys: arrayMove(rolesKeys, oldIndex, newIndex),
    }));
  };

  onDeleteStaff = (staffKey) => {
    const staff = { ...this.state.staff };
    delete staff[staffKey];

    this.setState({
      staffKeys: this.state.staffKeys.filter(
        (staffKeyCurr) => staffKeyCurr !== staffKey
      ),
      staff,
      isDeletedUser: true,
    });
  };

  onSortEndStaff = ({ oldIndex, newIndex }) => {
    this.setState(({ staffKeys }) => ({
      staffKeys: arrayMove(staffKeys, oldIndex, newIndex),
    }));
  };

  onTaskRemoveAll = () => {
    forEach(this.state.rolesKeys, (roleKey) => {
      this.props.form.setFieldsValue({
        [`roles[${roleKey}].tasks`]: [],
      });
    });
    this.setState({
      tasksKeys: [],
      tasks: {},
    });
  };

  onRoleRemoveAll = () => {
    forEach(this.state.staffKeys, (staffKey) => {
      this.props.form.setFieldsValue({
        [`staff[${staffKey}].roles`]: [],
      });
    });
    this.setState({
      rolesKeys: [],
      roles: {},
    });
  };

  onStaffRemoveAll = () => {
    this.setState({
      staffKeys: [],
      staff: {},
    });
  };

  quillModules = {
    toolbar: {
      container: [
        ["bold", "italic", "underline", "strike", "blockquote"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link"],
        ["clean"],
      ],
    },
  };

  render() {
    const {
      isLoading,
      requestResult,
      roleSearch,
      tasksKeys,
      rolesKeys,
      staffKeys,
      isStaffImportAllLoading,
      isStaffImportMissingLoading,
      isRolesImportMissingLoading,
      isRolesImportAllLoading,
    } = this.state;
    const { getFieldDecorator, getFieldValue } = this.props.form;
    const { delegationLogAdminUpdatePermission, delegationLog } = this.props;

    const isEditable =
      delegationLogAdminUpdatePermission && delegationLog.status === "draft";

    const isEditableStaff =
      delegationLogAdminUpdatePermission &&
      [
        "ready_to_be_signed",
        "qi_signed",
        "signing_locked",
        "all_staff_signed",
        "qi_confirmed",
        "draft",
      ].includes(delegationLog.status);

    return (
      <div className={classes.wrapper}>
        <Form onSubmit={this.handleSubmit}>
          <h4 className="headline-default">Info</h4>

          <Row gutter={12}>
            <Col lg={12}>
              <label>
                <Form.Item label={this.props.i18n.t("NamespaceDelegationLogs:Sponsor")}>
                  {getFieldDecorator("sponsor_name", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "delegationLog.sponsor_name"),
                  })(<Input disabled={!isEditable} />)}
                </Form.Item>
              </label>
            </Col>
          </Row>
          <Row gutter={12}>
            <Col lg={12}>
              <label>
                <Form.Item label={this.props.i18n.t("NamespaceDelegationLogs:Description")}>
                  {getFieldDecorator("description", {
                    rules: [{ required: true, message: this.props.i18n.t("Required") }],
                    initialValue: get(this.props, "delegationLog.description"),
                  })(
                    <ReactQuill
                      ref={this.quillRef}
                      readOnly={!isEditable}
                      theme="snow"
                      modules={this.quillModules}
                    />
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col lg={12}>
              <label>
                <Form.Item label={this.props.i18n.t("NamespaceDelegationLogs:Note")}>
                  {getFieldDecorator("note", {
                    initialValue: get(this.props, "delegationLog.note"),
                  })(<Input.TextArea disabled={!isEditable} />)}
                </Form.Item>
              </label>
            </Col>
          </Row>

          <Row gutter={12}>
            <Col lg={12}>
              <label>
                <Form.Item label={this.props.i18n.t("NamespaceDelegationLogs:Template type")}>
                  {getFieldDecorator(`template_type`, {
                    initialValue: get(this.props, "delegationLog.template_type", null),
                  })(
                    <Select
                      disabled={!isEditable}
                      placeholder={this.props.i18n.t("Select")}
                    >
                      <Select.Option value={null}>{this.props.i18n.t("NamespaceDelegationLogs:- not set -")}</Select.Option>
                      <Select.Option value="long">{this.props.i18n.t("NamespaceDelegationLogs:Long")}</Select.Option>
                      <Select.Option value="short">{this.props.i18n.t("NamespaceDelegationLogs:Short")}</Select.Option>
                    </Select>
                  )}
                </Form.Item>
              </label>
            </Col>
          </Row>

          {get(this.props, "delegationLog.protocol_number") && (
            <Row gutter={12}>
              <Col lg={12}>
                <b>
                  {this.props.i18n.t("NamespaceDelegationLogs:Protocol number")}:{" "}
                  {get(this.props, "delegationLog.protocol_number")}

                  <br/><br/>
                </b>
              </Col>
            </Row>
          )}

          <h4 className="headline-default">{this.props.i18n.t("NamespaceDelegationLogs:Tasks")}</h4>

          {tasksKeys && tasksKeys.length > 0 && isEditable && (
            <div className={classes.addButtonWrapper}>
              <Button
                type="danger"
                size="small"
                htmlType="button"
                onClick={this.onTaskRemoveAll}
              >
                {this.props.i18n.t("NamespaceDelegationLogs:Remove all")}
              </Button>
            </div>
          )}

          <SortableTaskList
            {...this.props}
            {...this.state}
            useDragHandle={true}
            isEditable={isEditable}
            axis="xy"
            onDeleteTask={this.onDeleteTask}
            onSortEnd={this.onSortEndTasks}
          />

          {isEditable && (
            <div className={classes.addButtonWrapper}>
              <Button
                type="primary"
                size="small"
                htmlType="button"
                onClick={this.onTaskAdd}
              >
                <Icon type="plus" />
                {this.props.i18n.t("NamespaceDelegationLogs:Add task")}
              </Button>
            </div>
          )}

          <div className={classes.separator} />

          <h4 className="headline-default">{this.props.i18n.t("NamespaceDelegationLogs:Roles")}</h4>

          {isEditable && (
            <div className={classes.addButtonWrapper}>
              <Button
                type="primary"
                size="small"
                loading={isRolesImportAllLoading}
                htmlType="button"
                onClick={this.getRolesImportAll}
                style={{ marginRight: "10px" }}
              >
                {this.props.i18n.t("NamespaceDelegationLogs:Import and replace current")}
              </Button>
              <Button
                type="primary"
                size="small"
                loading={isRolesImportMissingLoading}
                htmlType="button"
                onClick={this.getRolesImportMissing}
                style={{ marginRight: "10px" }}
              >
                {this.props.i18n.t("NamespaceDelegationLogs:Import and add missing")}
              </Button>
              {rolesKeys && rolesKeys.length > 0 && (
                <Button
                  type="danger"
                  size="small"
                  htmlType="button"
                  onClick={this.onRoleRemoveAll}
                >
                  {this.props.i18n.t("NamespaceDelegationLogs:Remove all")}
                </Button>
              )}
            </div>
          )}

          <SortableRolesList
            {...this.props}
            {...this.state}
            useDragHandle={true}
            isEditable={isEditable}
            axis="xy"
            onDeleteRole={this.onDeleteRole}
            onSortEnd={this.onSortEndRole}
            roleSearch={roleSearch}
            onBlurRole={this.onBlurRole}
            onSearchRole={this.onSearchRole}
          />

          {isEditable && (
            <div className={classes.addButtonWrapper}>
              <Button
                type={
                  tasksKeys && tasksKeys.length > 0 ? "primary" : "secondary"
                }
                size="small"
                htmlType="button"
                onClick={this.onRoleAdd}
                disabled={!(tasksKeys && tasksKeys.length > 0)}
              >
                <Icon type="plus" />
                {this.props.i18n.t("NamespaceDelegationLogs:Add role")}
              </Button>
            </div>
          )}

          <div className={classes.separator} />

          <h4 className="headline-default">{this.props.i18n.t("NamespaceDelegationLogs:Users")}</h4>

          {(isEditable || isEditableStaff) && (
            <div className={classes.addButtonWrapper}>
              <Button
                type="primary"
                size="small"
                loading={isStaffImportAllLoading}
                htmlType="button"
                onClick={this.getStaffImportAll}
                style={{ marginRight: "10px" }}
              >
                {this.props.i18n.t("NamespaceDelegationLogs:Import and replace current")}
              </Button>
              <Button
                type="primary"
                size="small"
                loading={isStaffImportMissingLoading}
                htmlType="button"
                onClick={this.getStaffImportMissing}
                style={{ marginRight: "10px" }}
              >
                {this.props.i18n.t("NamespaceDelegationLogs:Import and add missing")}
              </Button>
              {staffKeys && staffKeys.length > 0 && isEditableStaff && (
                <Button
                  type="danger"
                  size="small"
                  htmlType="button"
                  onClick={this.onStaffRemoveAll}
                >
                  {this.props.i18n.t("NamespaceDelegationLogs:Remove all")}
                </Button>
              )}
            </div>
          )}

          <SortableStaffList
            {...this.props}
            {...this.state}
            useDragHandle={true}
            isEditable={isEditable}
            isEditableStaff={isEditableStaff}
            axis="xy"
            onDeleteStaff={this.onDeleteStaff}
            onSortEnd={this.onSortEndStaff}
          />

          {(isEditable || isEditableStaff) && (
            <div className={classes.addButtonWrapper}>
              <Button
                type={
                  rolesKeys && rolesKeys.length > 0 ? "primary" : "secondary"
                }
                size="small"
                htmlType="button"
                onClick={this.onStaffAdd}
                disabled={!(rolesKeys && rolesKeys.length > 0)}
              >
                <Icon type="plus" />
                {this.props.i18n.t("NamespaceDelegationLogs:Add user")}
              </Button>
            </div>
          )}

          <div className={classes.separator} />

          {requestResult.type && (
            <Alert
              message={requestResult.message}
              type={requestResult.type}
              className={classes.submitResult}
            />
          )}

          <div className={classes.actionWrapper}>
            {(isEditable || isEditableStaff) && (
              <Form.Item>
                <Button
                  type={
                    tasksKeys &&
                    tasksKeys.length > 0 &&
                    rolesKeys &&
                    rolesKeys.length > 0 &&
                    staffKeys &&
                    staffKeys.length > 0
                      ? "primary"
                      : "secondary"
                  }
                  size="large"
                  htmlType="submit"
                  onClick={(e) => {
                    if (
                      this.state.isDeletedUser &&
                      get(this.props, "delegationLog.status") !== "draft"
                    ) {
                      e.preventDefault();

                      this.props.form.validateFields().then(() => {
                        this.setState({
                          isEndDelegationConfirmOpen: true,
                        });
                      });
                    }
                  }}
                  className={classes.submitButton}
                  disabled={
                    !(
                      tasksKeys &&
                      tasksKeys.length > 0 &&
                      rolesKeys &&
                      rolesKeys.length > 0 &&
                      staffKeys &&
                      staffKeys.length > 0
                    )
                  }
                >
                  {this.props.i18n.t("Save")}
                  {isLoading && <Icon type="loading" />}
                </Button>
                &nbsp; &nbsp;
              </Form.Item>
            )}
          </div>

          <Modal
            title={this.props.i18n.t(
              "NamespaceDelegationLogs:Some users were terminated from delegation log. Please confirm."
            )}
            visible={this.state.isEndDelegationConfirmOpen}
            footer={null}
            // onOk={this.handleSubmit}
            // onCancel={() => {
            //   this.setState({
            //     isEndDelegationConfirmOpen: false,
            //   });
            // }}
          >
            {this.state.isEndDelegationConfirmOpen && (
              <div>
                <Form.Item>
                  {getFieldDecorator("confirm", {
                    rules: [
                      {
                        required: true,
                        transform: (value) => value || undefined, // Those two lines
                        type: "boolean",
                        message: this.props.i18n.t("Required"),
                      },
                    ],
                    valuePropName: "checked",
                  })(
                    <Checkbox>
                      <span style={{ fontSize: "18px", fontWeight: 600 }}>
                        {this.props.i18n.t("Confirm")}
                      </span>
                    </Checkbox>
                  )}
                </Form.Item>

                <Signature
                  label={this.props.i18n.t("NamespaceDelegationLogs:Initials")}
                  fieldName="initials"
                  form={this.props.form}
                  isRequired={true}
                />

                <div className={classes.actionWrapper}>
                  <Button
                    type="primary"
                    htmlType="submit"
                    onClick={this.handleSubmit}
                    className={classes.submitButton}
                    loading={isLoading}
                  >
                    {this.props.i18n.t("Save")}
                  </Button>
                  &nbsp; &nbsp;
                  <Button
                    type="default"
                    htmlType="button"
                    className={classes.submitButton}
                    onClick={() => {
                      this.setState({
                        isEndDelegationConfirmOpen: false,
                      });
                    }}
                  >
                    {this.props.i18n.t("Cancel")}
                  </Button>
                </div>
              </div>
            )}
          </Modal>
        </Form>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  delegationLogAdminUpdatePermission: getDelegationLogAdminUpdatePermission(
    state
  ),
});

const mapDispatchToProps = { logout };

export default Form.create({ name: "DelegationLogForm" })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(DelegationLogForm))
);



// WEBPACK FOOTER //
// ./src/containers/DelegationLogs/DelegationLogForm.js